var _a, _b, _c, _d, _e, _f, _g, _h;
import { TABLET_WIDTH } from "@codex/utils/constants";
var styles = (_a = {
        root: (_b = {
                textAlign: "center"
            },
            _b["& .ant-select-auto-complete"] = {
                height: '0 !important',
                lineHeight: '0 !important',
                overflow: 'hidden !important',
                display: 'block !important'
            },
            _b),
        tagsInput: (_c = {
                direction: "rtl",
                display: "flex",
                alignItems: "center",
                flexWrap: "wrap",
                minHeight: 54,
                padding: "0 8px",
                borderRadius: 6,
                opacity: 0.99,
                border: "solid 1px #e0dede",
                backgroundColor: "#ffffff"
            },
            _c["&:focus-within"] = {
                border: "1px solid #40a9ff"
            },
            _c["& input"] = (_d = {
                    border: "none",
                    padding: "0 8px 0 0 !important",
                    fontSize: 14,
                    flex: 1,
                    boxShadow: "none !important",
                    outline: "transparent !important"
                },
                _d["&::placeholder"] = {
                    color: '#cbd1d7'
                },
                _d["&:disabled"] = {
                    backgroundColor: "transparent",
                    cursor: "not-allowed"
                },
                _d),
            _c),
        tags: {
            display: "flex",
            flexWrap: "wrap",
            padding: 0,
            margin: "8px 0 0 0"
        },
        tag: (_e = {
                width: "auto",
                height: 32,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#fff",
                padding: "0 8px",
                fontSize: 14,
                listStyle: "none",
                margin: "0 8px 8px 0",
                borderRadius: 27,
                border: "solid 1px #4bb0dd",
                backgroundColor: "#4bb0dd"
            },
            _e["& .tag-title"] = {
                marginTop: 3
            },
            _e["& .tag-close-icon"] = {
                display: "block",
                width: 16,
                height: 16,
                lineHeight: 16,
                textAlign: "center",
                fontSize: 14,
                marginRight: 8,
                borderRadius: "50%",
                cursor: "pointer"
            },
            _e),
        choice: (_f = {
                width: "auto",
                // height: 30,
                opacity: 0.99,
                borderRadius: 27,
                display: "inline",
                textAlign: "center",
                border: "solid 1px #4bb0dd",
                padding: "2px 12px",
                margin: "5px 4px",
                cursor: "pointer",
                minWidth: 103
            },
            _f["& span"] = {
                height: 24,
                opacity: 0.99,
                fontFamily: "Assistant",
                fontSize: 15,
                fontWeight: "normal",
                fontStyle: "normal",
                fontStretch: "normal",
                lineHeight: 1.6,
                letterSpacing: "normal",
                textAlign: "center",
                color: "#4bb0dd"
            },
            _f),
        choicesContainer: {
            marginTop: 8,
            display: "flex",
            flexWrap: "wrap",
            flexDirection: "row-reverse"
        },
        showMoreBtn: (_g = {},
            _g['& span'] = {
                color: '#4bb0dd',
                fontSize: 16,
                fontWeight: 'normal',
                fontStyle: 'normal',
                fontStretch: 'normal',
                lineHeight: 1.5,
                letterSpacing: 'normal'
            },
            _g["&:hover"] = (_h = {},
                _h['& span'] = {
                    textDecoration: "underline"
                },
                _h),
            _g)
    },
    _a["@media screen and (max-width:" + TABLET_WIDTH + "px)"] = {
        choice: {
            padding: "7px 8.5px"
        },
        tag: {
            height: 40
        },
        showMoreBtn: {
            marginTop: 2
        }
    },
    _a);
export default styles;



//////////////////
// WEBPACK FOOTER
// ./src/components/TagSelect/styles.ts
// module id = 1487
// module chunks = 0